const NUMBER_2_DOW = {
  0: 'Sun',
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
};

export function dayOfWeek2Text(daw) {
  return NUMBER_2_DOW[daw];
};

const NUMBER_2_COLOR = {
  0: '-weekend',
  1: '',
  2: '',
  3: '',
  4: '',
  5: '',
  6: '-weekend',
};
export function dayOfWeekColor(daw) {
  return NUMBER_2_COLOR[daw];
};

const NUMBER_2_MONTH = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};

export function month2Text(month) {
  return NUMBER_2_MONTH[month];
};

export function isToday(day) {
  const date = new Date();
  // debugger;
  return day.dom == date.getDate() && day.dow == date.getDay() && day.year == date.getFullYear();
};

export function truncatedDate(dateObj) {
  return new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());
}

export const differentDays = (date1, date2) => {
  if (!date1 || !date2) {
    return true;
  };
  return truncatedDate(date1).getUTCDate() !== truncatedDate(date2).getUTCDate();
};



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/Utils.js